// Some system browsers do not expose the modern Clipboard API to websites.
// Try their older copy command before asking the user to select the URL manually.
export async function copyInstallLink(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch { /* Try the browser's older copy command. */ }
  if (typeof document.execCommand !== 'function') return false;
  const previousFocus = document.activeElement;
  const input = document.createElement('textarea');
  input.value = text;
  input.readOnly = true;
  input.setAttribute('aria-label', '复制网站网址');
  input.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;';
  // Stay inside the dialog's focus trap so it cannot steal the selection.
  (document.querySelector('[role="dialog"]') ?? document.body).appendChild(input);
  try {
    input.focus({ preventScroll: true });
    input.select();
    input.setSelectionRange(0, text.length);
    return document.execCommand('copy') === true;
  } catch {
    return false;
  } finally {
    input.remove();
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  }
}
